<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font"
            >Middleman管理</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="item_font">规则配置</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div style="width: 660px; margin: 60px auto" class="item_font">
        <el-form
          id="selectForm"
          label-position="right"
          label-width="180px"
          :model="form"
          ref="form"
          :rules="formRules"
        >
          <el-form-item prop="firstReplyTime" label="首次回消息时间:">
            <el-col :span="6">
              <el-input v-model.number="form.firstReplyTime"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位:秒，默认3，范围：1~10)</span
              >
              <el-tooltip
                effect="dark"
                content="机器人返回的话术按分隔符分隔，分隔的第一句话术称为“首句”，回复首句的等待时间称为“首次回消息时间(秒)”。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>
          <el-form-item prop="typewriteTime" label="每个字打字时间:">
            <el-col :span="6">
              <el-input v-model.number="form.typewriteTime"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位:毫秒，默认200，范围：100~2000)</span
              >
              <el-tooltip
                effect="dark"
                content="客服输入框中输入的单个字所花的时间(毫秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
          </el-form-item>
          <!--					<el-form-item prop="idleCheckCycleTime" label="空闲检查周期:">
						<el-col :span="16">
							<el-input v-model.number="form.idleCheckCycleTime"></el-input>
						</el-col>
						<el-tooltip class="item" effect="dark" content="检查客户未开口或长时间不说话会话列表的间隔时间(秒)。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>
					</el-form-item>-->
          <el-form-item prop="nomouthIdleTime" label="未开口空闲检测时间:">
            <el-col :span="6">
              <el-input v-model.number="form.nomouthIdleTime"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位：秒，默认8，范围：5~20)</span
              >
              <el-tooltip
                effect="dark"
                content="未开口客户开口话术回复的间隔时间（间隔时间=未开口空闲检测时间+次数*空闲增量时间）(秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
            <!--						<el-tooltip class="item" effect="dark" content="未开口客户开口话术回复的间隔时间（间隔时间=未开口空闲检测时间+次数*空闲增量时间）(秒)。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>-->
          </el-form-item>
          <el-form-item prop="nomouthIdleNum" label="未开口空闲检测次数:">
            <el-col :span="6">
              <el-input v-model.number="form.nomouthIdleNum"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位：秒，默认5，范围：1~50)</span
              >
              <el-tooltip
                effect="dark"
                content="未开口客户开口话术回复的次数。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
            <!--						<el-tooltip class="item" effect="dark" content="未开口客户开口话术回复的次数。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>-->
          </el-form-item>
          <el-form-item prop="omouthIdleTime" label="开口空闲检测时间:">
            <el-col :span="6">
              <el-input v-model.number="form.omouthIdleTime"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位：秒，默认60，范围：30~120)</span
              >
              <el-tooltip
                effect="dark"
                content="开口客户一段时间未说话后，激活空闲检查到回复客户话术的时间(秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
            <!--						<el-tooltip class="item" effect="dark" content="开口客户一段时间未说话后，激活空闲检查到回复客户话术的时间(秒)。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>-->
          </el-form-item>
          <el-form-item prop="omouthIdleNum" label="开口空闲检测次数:">
            <el-col :span="6">
              <el-input v-model.number="form.omouthIdleNum"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位：秒，默认3，范围：1~10)</span
              >
              <el-tooltip
                effect="dark"
                content="开口后客户会话空闲检查的次数。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
            <!--						<el-tooltip class="item" effect="dark" content="开口后客户会话空闲检查的次数。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>-->
          </el-form-item>
          <el-form-item prop="idleIncrementTime" label="空闲次数增量时间:">
            <el-col :span="6">
              <el-input v-model.number="form.idleIncrementTime"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(单位：秒，默认2，范围：1~20)</span
              >
              <el-tooltip
                effect="dark"
                content="空闲次数每次增加后增加的话术回复时间(秒)。"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
            <!--						<el-tooltip class="item" effect="dark" content="空闲次数每次增加后增加的话术回复时间(秒)。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>-->
          </el-form-item>
          <!-- <el-form-item prop="idleIncrementTime" label="托管机器人  :">
            <el-col :span="6">
              <el-input v-model.number="form.idleIncrementTime"></el-input>
            </el-col>
            <el-col :span="16">
              <span style="margin-left: 10px"
                >(托管机器人)</span
              >
              <el-tooltip
                effect="dark"
                content="是否托管机器人"
                placement="top"
              >
                <i
                  class="el-icon-info"
                  style="margin-left: 10px; color: #6f6f6f"
                ></i>
              </el-tooltip>
            </el-col>
           
          </el-form-item> -->
          <!--					<el-form-item prop="pollingTime" label="客户消息轮询时间:">
						<el-col :span="16">
							<el-input v-model.number="form.pollingTime"></el-input>
						</el-col>
						<el-tooltip class="item" effect="dark" content="客户多次发送消息，将其合并为一条发送至机器人服务的间隔时间(秒)。" placement="top">
							<el-col :span="4"><i class="el-icon-info" style="margin-left: 10px;"></i></el-col>
						</el-tooltip>
					</el-form-item>-->
          <el-form-item style="margin-top: 60px">
            <el-button
              type="primary"
              @click="setRulesRequest('form')"
              class="item_font"
              >修改配置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    var validateFirstReplyTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 1 || value > 10) {
        callback(new Error("请输入1~10的正整数"));
      } else {
        callback();
      }
    };

    var validateIdleCheckCycleTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 0) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };

    var validateIdleIncrementTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 1 || value > 20) {
        callback(new Error("请输入1~20的正整数"));
      } else {
        callback();
      }
    };

    var validateNomouthIdleNum = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 1 || value > 50) {
        callback(new Error("请输入1~50的正整数"));
      } else {
        callback();
      }
    };

    var validateAnomouthIdleTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 5 || value > 20) {
        callback(new Error("请输入5~20的正整数"));
      } else {
        callback();
      }
    };

    var validateOmouthIdleNum = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 1 || value > 10) {
        callback(new Error("请输入1~10的正整数"));
      } else {
        callback();
      }
    };

    var validateOmouthIdleTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 30 || value > 120) {
        callback(new Error("请输入30~120的正整数"));
      } else {
        callback();
      }
    };

    var validatePollingTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 0) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };

    var validateTypewriteTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("该配置不能为空"));
      } else if (!Number.isInteger(value) || value < 100 || value > 2000) {
        callback(new Error("请输入100~2000的正整数"));
      } else {
        callback();
      }
    };

    return {
      form: {
        firstReplyTime: "3",
        idleCheckCycleTime: "",
        idleIncrementTime: "2",
        nomouthIdleNum: "5",
        nomouthIdleTime: "8",
        omouthIdleNum: "3",
        omouthIdleTime: "60",
        pollingTime: "",
        typewriteTime: "200",
      },
      formRules: {
        firstReplyTime: [
          { validator: validateFirstReplyTime, trigger: "change" },
        ],
        idleCheckCycleTime: [
          { validator: validateIdleCheckCycleTime, trigger: "change" },
        ],
        idleIncrementTime: [
          { validator: validateIdleIncrementTime, trigger: "change" },
        ],
        nomouthIdleNum: [
          { validator: validateNomouthIdleNum, trigger: "change" },
        ],
        nomouthIdleTime: [
          { validator: validateAnomouthIdleTime, trigger: "change" },
        ],
        omouthIdleNum: [
          { validator: validateOmouthIdleNum, trigger: "change" },
        ],
        omouthIdleTime: [
          { validator: validateOmouthIdleTime, trigger: "change" },
        ],
        pollingTime: [{ validator: validatePollingTime, trigger: "change" }],
        typewriteTime: [
          { validator: validateTypewriteTime, trigger: "change" },
        ],
      },
    };
  },

  created() {
    this.getRulesRequest();
  },

  methods: {
    async getRulesRequest() {
      var api = "/manager/middleman/manage/get/rule";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (response.resultCode == 10000) {
        this.form = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },

    setRulesRequest(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          this.submitData();
        } else {
          this.$message.error("请注意查看配置信息是否正确!");
          return false;
        }
      });
    },

    async submitData() {
      var api = "/manager/middleman/manage/set/rule";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          firstReplyTime: this.form.firstReplyTime,
          idleCheckCycleTime: this.form.idleCheckCycleTime,
          idleIncrementTime: this.form.idleIncrementTime,
          nomouthIdleNum: this.form.nomouthIdleNum,
          nomouthIdleTime: this.form.nomouthIdleTime,
          omouthIdleNum: this.form.omouthIdleNum,
          omouthIdleTime: this.form.omouthIdleTime,
          pollingTime: this.form.pollingTime,
          typewriteTime: this.form.typewriteTime,
        },
      });
      if (response.resultCode != 10000) {
        this.$message.error(response.desc);
      } else {
        this.$message.success("修改配置成功!");
      }
    },
  },
};
</script>

<style scoped="scoped"></style>
